module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAOBAMAAADZH/H+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpcYqKioiIiIiIiIeHh4iIiIiIiIeHh4iIiIaGhoeHh4iIiIeHh4iIiGdZky8AAAANdFJOUwAQOfWKcJ2v4ibH1VygU8BrAAAAW0lEQVQI12PwvQsDVxi44OwFDIy2UOZlAQaGuVD2TQYGBh4o+wCQzZALZl4DMRm4wewNYDZYN0gnCOgC2ZcgTAZWIDsAymaovXsdxmTguNsAZzPeFYCzGZTAJABfukBaGgoZ7gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/cs180824/img/icon-arrow-down.png
// module id = YKIZ
// module chunks = 2 3